import { action, observable, when } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { transl } from '../main/transl';
import { getOmnistore } from '../stores/Omnistore';

@observer export class ErrorBoundary extends React.Component<{children: React.ReactNode}> {
	@observable _page: string | undefined
	@observable _error: Error | undefined
	@observable _errorInfo: React.ErrorInfo | undefined

	@action _clear = () => {
		console.log('_clear');
		this._page = undefined;
		this._error = undefined;
		this._errorInfo = undefined;
	}

	@action componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		const locationStore = getOmnistore().locationStore;
		this._page = locationStore.page;
		this._error = error;
		this._errorInfo = errorInfo;
		console.log('ErrorBoundary', locationStore.page, error, errorInfo);
		when(() => locationStore.page !== this._page, this._clear);
	}

	render() {
		if (!this._errorInfo) return this.props.children;
		return <div>
			<h2>{transl('somethingWentWrong')}</h2>
			<details open style={{whiteSpace: 'pre-wrap'}}>
				{this._error && this._error.toString()}
				<br/>
				{this._errorInfo.componentStack}
			</details>
		</div>;
	}
}
